/**
 * @EXCEL functions
 * функції електронних таблиць, які використовуються у проекті
*/

/**
 * @excel SUM
*/
const SUM = arr => arr.reduce((a, b) => {
	if (typeof b === 'number') {
		return a + b;
	}
	return a;
}, 0);

/**
 * @excel PTM
*/
const PMT = (rate, nper, pv, fv, type) => {
	if (!fv) fv = 0;
	if (!type) type = 0;
	if (rate === 0) return -(pv + fv) / nper;
	const pvif = Math.pow(1 + rate, nper);
	let pmt = rate / (pvif - 1) * -(pv * pvif + fv);
	if (type === 1) pmt /= (1 + rate);
	return pmt;
};

/**
 * @excel PV
*/
const PV = (rate, periods, payment, future, type) => {
	type = (typeof type === 'undefined') ? 0 : type;
	future = (typeof future === 'undefined') ? 0 : future;
	let pv;
	if (rate === 0) {
		pv = -payment * periods - future;
	}
	else {
		pv = (((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 + rate * type) - future) / Math.pow(1 + rate, periods);
	}
	return pv;
};

export { SUM, PMT, PV };
